<template>
    <div class="container">
        <o-bread-crumb>
            <template v-slot:pageName>
                Voucher Redeem
            </template>
            <template v-slot:pageDetail>
                List
            </template>
        </o-bread-crumb>

        <FeatureGate featureKey="point_control">
        <div v-if="validation">
            <div class="alert alert-danger mt-1" role="alert">
                {{ validation }}
            </div>
        </div>
        <div v-if="thisComponentShow" class="card text-center bg-white shadow-none">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills justify-content-between ms-2 me-4 mt-2 mb-2">
                    <li class="nav-item text-start">
                        <div class="d-flex d-inline-block">
                            <h4 class="header-title">
                                <i class="fas fa-ticket-alt me-2 text-primary"></i>List of Voucher Redeems
                            </h4>
                        </div>
                        <p class="header-subtitle me-4 mt-1">Manage and view all voucher redeems</p>   
                    </li>
                </ul>
            </div>
            <div v-if="$route.query.error" class="alert alert-danger">
                {{ $route.query.error }}
            </div>
            <div class="card-body">
            <div class="d-flex justify-content-center spinner-border text-primary spinner-position" v-if="page.isLoading"></div>
            <div class="spinner" v-if='page.isLoading'></div>
            <div class="">
                <div class="filter-action-wrapper mb-4 mt-3">
                    <div class="filter-controls">
                        <!-- Merchant Selection (Admin/Corporate only) -->
                        <div class="merchant-filter" v-if="selectedBusinessProfile.merchant_id == null">
                            <o-select v-model="selectMerchant" :options="merchants" autocomplete="'off'" placeholder="Select Merchant"></o-select>
                        </div>

                        <!-- Search Control (Tabs + Input) -->
                        <div class="search-box-custom">
                            <div class="search-type-tabs">
                                <button 
                                    v-for="option in availableSearchOptions" 
                                    :key="option.value"
                                    class="tab-btn"
                                    :class="{ active: searchOptions === option.value }"
                                    @click="searchOptions = option.value"
                                >
                                    {{ option.text }}
                                </button>
                            </div>
                            <div class="search-input-wrapper" v-if="searchOptions !== 'voucher_type'">
                                <input 
                                    type="text" 
                                    class="form-control-search" 
                                    v-model="searchKeyword" 
                                    placeholder="Search..." 
                                    @keyup.enter="handleSearchChange()" 
                                />
                                <button v-if="!isSearchActive" class="btn-search" @click="handleSearchChange()">
                                    <i class="fas fa-search"></i>
                                </button>
                                <button v-else class="btn-search" @click="clearSearchOption()">
                                    <i class="fas fa-times text-danger"></i>
                                </button>
                            </div>
                            <div class="search-input-wrapper" v-if="searchOptions === 'voucher_type'">
                                <select class="form-select custom-select-transparent" v-model="searchKeyword" @change="handleSearchChange()">
                                    <option value="">Select Type</option>
                                    <option value="credit_discount">Credit Discount</option>
                                    <option value="product_service">Product & Service</option>
                                </select>
                                <button v-if="isSearchActive" class="btn-search" @click="clearSearchOption()">
                                    <i class="fas fa-times text-danger"></i>
                                </button>
                            </div>
                        </div>

                        <!-- Date Range Box -->
                        <div class="filter-section">
                            <div class="section-label-tabs">
                                <span class="label-tab">Date Range</span>
                            </div>
                            <div class="date-range-box">
                                <div class="date-input-group">
                                    <div class="input-container">
                                        <input
                                            placeholder="Select Date Range"
                                            ref="datePicker"
                                        />
                                        <button v-if="isDateRangeActive" class="btn-clear-date" @click="clearDateRange" title="Clear Date Range" type="button">
                                            <i class="fas fa-times text-danger"></i>
                                        </button>
                                        <i v-else class="fas fa-calendar-alt calendar-icon"></i>
                                        <Transition name="fade">
                                            <div v-if="showDateTip" class="date-selection-tip">
                                                <i class="fas fa-info-circle me-1"></i>
                                                Please select another date to complete the range
                                            </div>
                                        </Transition>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Claimed Voucher Filter -->
                        <div class="filter-section">
                            <div class="section-label-tabs">
                                <span class="label-tab">Voucher Status</span>
                            </div>
                            <div class="search-type-tabs">
                                <button type="button" class="tab-btn" :class="{ active: draftClaimedVoucher === 'all' }" @click="draftClaimedVoucher = 'all'; handleSearchChange()">All</button>
                                <button type="button" class="tab-btn" :class="{ active: draftClaimedVoucher === 'claimed' }" @click="draftClaimedVoucher = 'claimed'; handleSearchChange()">Claimed</button>
                                <button type="button" class="tab-btn" :class="{ active: draftClaimedVoucher === 'redeemed' }" @click="draftClaimedVoucher = 'redeemed'; handleSearchChange()">Redeemed</button>
                            </div>
                        </div>
                    </div>

                    <div class="action-section">
                        <div class="action-buttons-group">
                            <button class="btn btn-export" @click.prevent="download_state()">
                                <i class="fas fa-file-export me-1"></i> Export
                            </button>
                            <button v-if="write" @click="openAddModal" class="btn btn-add" type="button">
                                <i class="fas fa-plus me-1"></i> Add New
                            </button>
                        </div>
                    </div>
                </div>
                <o-table style="text-align:left;" class="table-hover voucher-list-table">
                    <thead>
                        <tr>
                            <td class="fw-bolder text-muted" scope="col" v-for="(field, index) in fields" :key="index">
                                {{ field }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in voucherRedeems" :key="index" class="voucher-row-clickable">
                            <td>{{ (meta.page - 1) * meta.limit + index + 1 }}</td>
                            <td>
                                <div class="text-truncate-2" :title="item.voucher.name" style="max-width: 250px;">
                                    {{ item.voucher.name }}
                                </div>
                            </td>
                            <td>
                                <span class="badge text-dark" :class="item.voucher.voucher_type === 'credit_discount' ? 'status-active' : 'status-primary'">
                                    {{ item.voucher.voucher_type === 'credit_discount' ? 'Credit Discount' : 'Product & Service' }}
                                </span>
                            </td>
                            <td>
                                <div class="text-truncate-2" :title="`${item.member.title ? item.member.title + ' ' : ''}${item.member.first_name || ''} ${item.member.last_name || ''}`" style="max-width: 200px;">
                                    {{ item.member.title }} {{ item.member.first_name }} {{ item.member.last_name }}
                                </div>
                            </td>
                            <td>
                                <span :class="item.source === 'gift' ? 'badge bg-success' : 'badge bg-secondary'">
                                    {{ item.source === 'gift' ? 'Gift' : 'Redeem' }}
                                </span>
                            </td>
                            <td>
                                <div class="modern-date" v-if="item.created_at">
                                    <span class="date-main">{{ formatDateOnly(item.created_at, false) }}</span>
                                    <span class="time-sub"><i class="far fa-clock"></i> {{ formatTimeOnly(item.created_at, false) }}</span>
                                </div>
                                <span v-else class="badge status-default text-dark">N/A</span>
                            </td>
                            <td>
                                <div class="modern-date" v-if="item.claimed_at">
                                    <span class="date-main">{{ formatDateOnly(item.claimed_at, false) }}</span>
                                    <span class="time-sub"><i class="far fa-clock"></i> {{ formatTimeOnly(item.claimed_at, false) }}</span>
                                </div>
                                <span v-else class="badge status-default text-dark">N/A</span>
                            </td>
                            <td>
                                <div class="modern-date" v-if="item.expired_at">
                                    <span class="date-main">{{ formatDateOnly(item.expired_at, false) }}</span>
                                    <span class="time-sub"><i class="far fa-clock"></i> {{ formatTimeOnly(item.expired_at, false) }}</span>
                                </div>
                                <span v-else class="badge status-default text-dark">N/A</span>
                            </td>
                            <td>
                                <span class="badge text-dark text-capitalize" :class="item.expired_status === 'expired' ? 'status-danger' : 'status-default'">
                                    {{ item.expired_status ?? 'N/A' }}
                                </span>
                            </td>
                            <td>
                                <span class="badge text-dark text-capitalize" :class="item.cancelled_status === 'cancelled' ? 'status-danger' : 'status-default'">
                                    {{ item.cancelled_status ?? 'N/A' }}
                                </span>
                            </td>
                            <td>
                                <div class="text-truncate-2" :title="getVoucherMerchantDisplayName(item.voucher)" style="max-width: 200px;">
                                    {{ getVoucherMerchantDisplayName(item.voucher) }}
                                </div>
                            </td>
                            <td class="ml-3">
                                <div class="d-flex gap-2">
                                    <div v-if="item.claimed_at == null && item.expired_status != 'expired' && item.cancelled_status != 'cancelled'">
                                        <button class="btn btn-action btn-claim" v-if="write" @click="openClaimModal(item.id)" type="button">
                                            <i class="fas fa-ticket-alt me-1"></i> Claim Now
                                        </button>
                                    </div>
                                    <div v-else>
                                        <button class="btn btn-action btn-info-action" @click="openInfoModal(item.id)" type="button">
                                            <i class="fas fa-eye me-1"></i> Info
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="voucherRedeems.length === 0">
                            <td colspan="12" class="text-center">No voucher redemptions available</td>
                        </tr>
                    </tbody>
                </o-table>
                
                <div class="pagination-wrapper">
                    <o-pagination 
                        :key="`pagination-${meta.page}-${meta.total}-${paginationKey}`"
                        :page="meta.page" 
                        :total="meta.total" 
                        @callback="navPage"
                    />
                </div>
            </div>
            </div>
            </div>

        </FeatureGate>
    </div>
    <br>

    <voucher-redeem-form
        v-if="modal.visible && (modal.type === 'add' || modal.type === 'claim')"
        :is-modal="true"
        :redeem-id="modal.redeemId"
        @success="handleModalSuccess"
        @cancel="handleModalClose"
    />
    <voucher-redeem-info
        v-if="modal.visible && modal.type === 'info'"
        :is-modal="true"
        :redeem-id="modal.redeemId"
        @cancel="handleModalClose"
    />

</template>

<script>

import store from '@/store/'
import {mapState} from 'vuex'
import {OTable, OPagination, OBreadCrumb, OSelect}
    from '@/components/OmnihControl'
import FeatureGate from '@/components/upsell/FeatureGate.vue';
import { computed, onMounted, reactive, ref, watch, onBeforeUnmount, nextTick } from 'vue'
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

import VoucherRedeemForm from './VoucherRedeemForm.vue';
import VoucherRedeemInfo from './VoucherRedeemInfo.vue';

export default {
    components:{
        OTable,
        OPagination,
        OBreadCrumb,
        OSelect,
        FeatureGate,
        VoucherRedeemForm,
        VoucherRedeemInfo
    },
    setup() {
        let meta = computed(() => store.state.VoucherRedeem.meta)

        let page = reactive({
            isLoading: false,
            output: false,
            component: 'voucher_redeem'
        });

        let fields = ref([
            'No',
            'Voucher Name',
            'Voucher Type',
            'Member Name',
            'Source',
            'Redeem Date',
            'Claimed Date',
            'Expired Date',
            'Expired Status',
            'Canceled Status',
            'Provided By',
            'Action'
        ]);

        const merchants = ref([]);

        const selectMerchant = ref();
        const validation = ref('');

        const selectedBusinessProfile = reactive({
            branch_id: null,
            merchant_id: null
        });

        const voucherRedeemSearch = ref([]);

        const selectVoucherRedeem = ref();

        const searchBy = reactive({
            selected:"code",
            criteria:"",
            date_start: "",
            date_end: ""
        })

        const dateRange = ref([null, null]);

        const showDateTip = ref(false);
        const isDateRangeActive = computed(() => dateRange.value.length === 2 && dateRange.value.every(date => date !== null));
        let flatpickrInstance = null;

        const datePicker = ref(null);

        const searchOptions = ref('voucher_name');
        const availableSearchOptions = [
            { value: 'voucher_name', text: 'Voucher Name' },
            { value: 'member_name', text: 'Member Name' },
            { value: 'voucher_type', text: 'Voucher Type' }
        ];

        const sortOptions = ref('');
        const availableSortOptions = [
            { value: 'expired_at', text: 'Expired Date' },
            { value: 'claimed_at', text: 'Claimed Date' },
            { value: 'created_at', text: 'Redeem Date' }
        ];

        const sortDesc = ref(true);

        const thisComponentShow = ref(true);

        const isStateLoaded = ref(false);

        const selfLoaded = ref(store.state.Auth.selfLoaded);

        const write = ref(false);

        const members = ref([]);

        const memberSelected = ref(false);

        const isSearchActive = ref(false);

        const searchBar = ref(true);

        const showTooltip = ref(false);

        const showSearchPlaceholder = ref(true);

        const showSortPlaceholder = ref(true);

        const claimedVoucher = ref('all');
        const draftClaimedVoucher = ref('all');

        const searchKeyword = ref('');

        const isMobile = ref(window.innerWidth <= 768);
        
        const checkMobileView = () => {
            isMobile.value = window.innerWidth <= 768;
        };

        const handleSelectedChanged = (newSelected) => {
            clearSearch();
            
            if (newSelected === 'member') {
                memberSelected.value = true;
                searchBar.value = false;
            } else {
                memberSelected.value = false;
                searchBar.value = true;
            }
        };

        watch(
            () => store.state.Auth.selfLoaded,
            (newVal) => {
                if (newVal) {
                    selfLoaded.value = newVal;
                    load_state();
                }
            }
        );

        const filterContainer = ref(null);
        let originalOffsetTop = 0;

        const handleScroll = () => {
            if (!filterContainer.value) return;
            
            const scrollY = window.scrollY;
            if (scrollY > originalOffsetTop) {
                filterContainer.value.style.position = 'fixed';
                filterContainer.value.style.top = '0';
                filterContainer.value.style.left = '0';
                filterContainer.value.style.right = '0';
            } else {
                filterContainer.value.style.position = 'static';
            }
        };

        onMounted(() => {
            originalOffsetTop = filterContainer.value?.offsetTop || 0;
            window.addEventListener('scroll', handleScroll);
            loadSelectedBusinessProfile().then(() => {

                if (datePicker.value && !flatpickrInstance) {
                    flatpickrInstance = flatpickr(datePicker.value, {
                        mode: 'range',
                        locale: {
                            rangeSeparator: ' to '
                        },
                        onChange: handleDateRangeChange,
                        onValueUpdate: (selectedDates) => {
                            showDateTip.value = selectedDates.length === 1;
                        },
                        onClose: () => {
                            showDateTip.value = false;
                        }
                    });
                }

                // Check if we're returning from VoucherRedeemInfo
                const isReturningFromInfo = sessionStorage.getItem('returningFromVoucherRedeemInfo');
                if (isReturningFromInfo === 'true') {
                    // Restore saved state
                    restoreSavedState();
                    sessionStorage.removeItem('returningFromVoucherRedeemInfo');
                } else {
                    if (isStateLoaded.value == false) {
                        load_state();
                        isStateLoaded.value = true;
                    }

                    if (selfLoaded.value) {
                        load_state();
                    }
                }

                if (selectedBusinessProfile.corporate_id != null) {
                    loadMembers();
                }
            
            }).catch(error => {
                console.error("Error loading business profile:", error);
                page.isLoading = false;
            });

            window.addEventListener('resize', checkMobileView);
        });

        onBeforeUnmount(() => {
            if (flatpickrInstance) {
                flatpickrInstance.destroy();
                flatpickrInstance = null;
            }

            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', checkMobileView);
        });



        function load_state(){
            page.isLoading = true;

            store.dispatch('VoucherRedeem/read')
            .then(function(){
                })
            .catch((err) => {
                validation.value = err.response.data.error ?? err.response.data.message;
                console.error(err);
            })
            .finally(()=>{
                page.isLoading = false;
                page.output=true;
            });

            if (store.state.Auth.currUser.level === 'root') {
                write.value = true;
            } else {
                const userModules = store.state.Auth.userInfo.modules;

                if (userModules) {
                    const matchingModule = userModules.find(module => module.module_name === page.component);
                    write.value = matchingModule ? matchingModule.write : false;
                } else {
                    console.error('userModules is undefined');
                    write.value = false;
                }
            }
        }

        function destroy(id) {
            page.isLoading = true;
            setTimeout(() => {
                page.isLoading = false;
            }, 5000);
            if(confirm("Do you really want to delete ?")){
                store.dispatch('VoucherRedeem/delete',id)
                .then(() => {
                    }).catch((err) => {
                        validation.value = err.message;
                    }).finally(() => {
                    page.isLoading = false;
                    });
            }else{
                page.isLoading = false;
            }
        }

        function navPage(page){
            const _meta = {... meta.value, page}

            store.commit('VoucherRedeem/switch_page',{meta:_meta})
            load_state()
        }

        function loadSelectedBusinessProfile() {
            return store.dispatch('Auth/getBusinessProfile').then((businessProfile) => {
                selectedBusinessProfile.branch_id = businessProfile.branch_id;
                selectedBusinessProfile.merchant_id = businessProfile.merchant_id;
                selectMerchant.value = businessProfile.merchant_id == null ? "all" : businessProfile.merchant_id;

                if (businessProfile.merchant_id == null) {
                    loadMerchants();
                }

                if (store.state.Auth.currUser.level === 'root') {
                    write.value = true;
                } else {
                    const userModules = store.state.Auth.userInfo.modules;

                    if (userModules) {
                        const matchingModule = userModules.find(module => module.module_name === page.component);
                        write.value = matchingModule ? matchingModule.write : false;
                    } else {
                        console.error('userModules is undefined');
                        write.value = false;
                    }
                }
            });
        }

        function loadMerchants() {
            const filter = {
                branch_id: selectedBusinessProfile.branch_id,
            }

            store.commit('Merchant/add_filter', {filter});
            store.dispatch('Merchant/read').then(() => {
                merchants.value = [{value: "all", text: "From all merchant"}, ...store.state.Merchant.merchants.map((merch)=>({'value':merch.id,'text':merch.name}))]
            })
        }

        function handleSelectedMember(memberId) {
            if (memberId != null) {
                search['member_id'] = memberId;

                store.commit('VoucherRedeem/clear_meta');

                store.commit('VoucherRedeem/set_search', {search});
                store.dispatch('VoucherRedeem/read').then(() => {})
                .catch((err) => {
                    validation.value = err.response.data.message;
                    thisComponentShow.value = false;
                    console.error(err);
                })
                .finally(() => page.output = true);
            } else {
                clearSearch();
            }            
        }

        function search(searchBy){
            const {selected, criteria, date_start, date_end} = searchBy;

            if (selected) {
                let search = {}

                if (criteria && selected !== 'created_at'){
                    search[selected] = criteria;
                }else if(date_start && date_end){
                    search[selected] = `${date_start}, ${date_end}`;
                }

                store.commit('VoucherRedeem/clear_meta');
                store.commit('VoucherRedeem/set_search', {search});
                store.dispatch('VoucherRedeem/read').then(() => {});
            }

        }

        function clearSearch(){
            store.commit('VoucherRedeem/clear_meta');
            store.commit('VoucherRedeem/clear_search');
            store.commit('VoucherRedeem/clear_filter');
            store.dispatch('VoucherRedeem/read').then(() => {});
        }

        function formatDateOnly(dateString, isUTC = true) {
            if (!dateString) return 'N/A';
            let dateStr = dateString;
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
                if (isUTC) dateStr += 'Z';
            }
            const date = new Date(dateStr);
            const day = date.getDate().toString().padStart(2, '0');
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const monthName = months[date.getMonth()];
            const year = date.getFullYear();
            return `${day} ${monthName} ${year}`;
        }

        function formatTimeOnly(dateString, isUTC = true) {
            if (!dateString) return '';
            let dateStr = dateString;
            if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                dateStr = dateStr.replace(' ', 'T');
                if (isUTC) dateStr += 'Z';
            }
            const date = new Date(dateStr);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 || 12;
            const formattedMinutes = minutes.toString().padStart(2, '0');
            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        }

        function formatDatePicker(dateInput, isUTC = true) {
            if (!dateInput) return '';
            let date;
            if (dateInput instanceof Date) {
                date = dateInput;
            } else {
                let dateStr = String(dateInput);
                if (dateStr.indexOf('T') === -1 && dateStr.indexOf('Z') === -1 && dateStr.length === 19) {
                    dateStr = dateStr.replace(' ', 'T');
                    if (isUTC) dateStr += 'Z';
                }
                date = new Date(dateStr);
            }
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        }

        watch(
            () => selectMerchant.value,
            () => {
                applyFilters();
            }
        )

        watch(
            () => isMobile.value,
            async (newVal, oldVal) => {
                
                if (!newVal && oldVal) {
                    await nextTick();
                    datePicker.value = flatpickr(datePicker.value, {
                        mode: 'range',
                        onChange: handleDateRangeChange
                    });
                }
            },
            { immediate: true }
        );

        function loadMembers(){

            const filter = {
                corporate_id: selectedBusinessProfile.corporate_id
            }

            store.commit('Member/add_filter', {filter});
            store.dispatch('Member/read').then(() => {
                members.value = [...store.state.Member.members.map((member) => ({
                    'value': member.id,
                    'text': `${member.title} ${member.first_name} ${member.last_name}`
                }))]
            })
        }

        const handleSearchChange = (option) => {
            if (!searchKeyword.value && option && !option.type) return; // Prevent empty search if triggered by button click
            showSearchPlaceholder.value = false;
            if (option && !option.type) {
                searchOptions.value = option.value;
            }
            if (searchKeyword.value) {
                isSearchActive.value = true;
            }
            applyFilters();
        };

        const handleSortChange = (option) => {
            showSortPlaceholder.value = false;
            if (option) {
                sortOptions.value = option.value;
            }
        };

        const clearSortOption = () => {
            sortOptions.value = '';
            showSortPlaceholder.value = true;
        };

        function refreshData(keepPage = false) {
            claimedVoucher.value = draftClaimedVoucher.value;
            const filter = {
                search_by: searchOptions.value,
                keyword: searchKeyword.value,
                sort_by: sortOptions.value,
                sort_order: sortDesc.value ? 'desc' : 'asc',
                show_claimed: claimedVoucher.value,
                ...(selectedBusinessProfile.merchant_id !== null ? {
                    merchant_id: selectedBusinessProfile.merchant_id
                } : {
                    merchant_id: selectMerchant.value !== 'all' ? selectMerchant.value : null,
                    branch_id: selectMerchant.value === 'all' ? selectedBusinessProfile.branch_id : null
                }),
                ...(dateRange.value.length === 2 && 
                    dateRange.value.every(date => date !== null) && { 
                        date_range: Array.isArray(dateRange.value) ? dateRange.value.join(',') : dateRange.value
                    })
            };
            if (!keepPage) {
                store.commit('VoucherRedeem/clear_meta');
            }
            store.commit('VoucherRedeem/add_filter', {filter});
            store.dispatch('VoucherRedeem/read').then(() => {
                paginationKey.value++;
            }).catch((err) => {
                validation.value = err.response?.data?.message || err.message || 'Something went wrong';
            });
            saveCurrentState();
        }

        function applyFilters() {
            refreshData(false);
        }

        function resetFilters() {
            searchOptions.value = '';
            sortOptions.value = '';
            sortDesc.value = true;
            dateRange.value = [null, null];
            searchKeyword.value = '';
            claimedVoucher.value = 'all';
            draftClaimedVoucher.value = 'all';
            showSearchPlaceholder.value = true;
            showSortPlaceholder.value = true;
            isSearchActive.value = false;
            clearSearch();
            clearDateRange();
            applyFilters();
        }

        const handleDateRangeChange = (selectedDates, dateStr, instance) => {
            if (selectedDates.length === 2) {
                const formattedStartDate = formatDatePicker(selectedDates[0]);
                const formattedEndDate = formatDatePicker(selectedDates[1]);

                const startDate = new Date(formattedStartDate);
                const endDate = new Date(formattedEndDate);

                const diffTime = Math.abs(endDate - startDate);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                let finalStart = formattedStartDate;
                let finalEnd = formattedEndDate;

                if (diffDays > 31) {
                    alert('Date range cannot exceed 31 days');
                    const newEndDate = new Date(startDate);
                    newEndDate.setDate(startDate.getDate() + 31);
                    finalEnd = formatDatePicker(newEndDate);

                    if (instance) {
                        instance.setDate([selectedDates[0], newEndDate]);
                        if (instance.input) {
                            instance.input.value = `${finalStart} to ${finalEnd}`;
                        }
                    }
                } else if (instance && instance.input) {
                    instance.input.value = `${finalStart} to ${finalEnd}`;
                }

                dateRange.value = [finalStart, finalEnd];
                showDateTip.value = false;
                applyFilters();
            }
        };

        const clearDateRange = () => {
            if (flatpickrInstance) {
                flatpickrInstance.clear();
            }
            dateRange.value = [null, null];
            showDateTip.value = false;
            applyFilters();
        };

        const clearSearchOption = () => {
            isSearchActive.value = false;
            searchKeyword.value = '';
            applyFilters();
        };

        const paginationKey = ref(0); // Untuk memaksa re-render pagination
        
        // Tambahkan watcher untuk sinkronisasi state lokal ke Vuex
        watch([
            searchOptions, sortOptions, sortDesc, claimedVoucher, searchKeyword, dateRange
        ], () => {
            saveCurrentState();
        }, { deep: true });

        // Fungsi untuk menyimpan state sebelum navigasi ke VoucherRedeemInfo
        const saveCurrentState = () => {
            const currentState = {
                scrollPosition: window.scrollY,
                filter: { ...store.state.VoucherRedeem.filter },
                search: { ...store.state.VoucherRedeem.search },
                meta: { ...store.state.VoucherRedeem.meta },
                searchOptions: searchOptions.value,
                sortOptions: sortOptions.value,
                sortDesc: sortDesc.value,
                claimedVoucher: claimedVoucher.value,
                searchKeyword: searchKeyword.value,
                dateRange: [...dateRange.value]
            };
            store.commit('VoucherRedeem/save_state', { savedState: currentState });
        };

        // Fungsi untuk memulihkan state yang tersimpan dari Vuex persisted state
        const restoreSavedState = () => {
            const savedState = store.state.VoucherRedeem.savedState;
            if (savedState && Object.keys(savedState).length > 0) {
                store.commit('VoucherRedeem/restore_state');
                searchOptions.value = savedState.searchOptions || '';
                sortOptions.value = savedState.sortOptions || '';
                sortDesc.value = savedState.sortDesc !== undefined ? savedState.sortDesc : true;
                claimedVoucher.value = savedState.claimedVoucher !== undefined ? savedState.claimedVoucher : 'all';
                draftClaimedVoucher.value = claimedVoucher.value;
                searchKeyword.value = savedState.searchKeyword || '';
                dateRange.value = savedState.dateRange || [null, null];
                showSearchPlaceholder.value = !searchOptions.value;
                showSortPlaceholder.value = !sortOptions.value;
                load_state();
                nextTick(() => {
                    if (savedState.scrollPosition) {
                        window.scrollTo(0, savedState.scrollPosition);
                    }
                    setTimeout(() => {
                        const currentMeta = { ...store.state.VoucherRedeem.meta };
                        store.commit('VoucherRedeem/switch_page', { meta: currentMeta });
                        paginationKey.value++;
                    }, 100);
                });
            } else {
                load_state();
            }
        };

        const modal = reactive({
            visible: false,
            type: null,
            redeemId: null
        });

        const openAddModal = () => {
            modal.type = 'add';
            modal.redeemId = null;
            modal.visible = true;
        };

        const openClaimModal = (itemId) => {
            modal.type = 'claim';
            modal.redeemId = itemId;
            modal.visible = true;
        };

        const openInfoModal = (itemId) => {
            modal.type = 'info';
            modal.redeemId = itemId;
            modal.visible = true;
        };

        const handleModalSuccess = () => {
            modal.visible = false;
            modal.type = null;
            modal.redeemId = null;
            refreshData(true);
        };

        const handleModalClose = () => {
            modal.visible = false;
            modal.type = null;
            modal.redeemId = null;
        };

        const handleInfoClick = (itemId) => {
            openInfoModal(itemId);
        };

        const handleClaimClick = (itemId) => {
            openClaimModal(itemId);
        };

        const download_state = async () => {
            page.isLoading = true;

            try {
                const response = await store.dispatch('VoucherRedeem/export');
                const blob = new Blob([response.data], { type: 'text/csv' });
                let fileName = 'Voucher-Redeems.csv';
                
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (fileNameMatch && fileNameMatch.length === 2) {
                        fileName = fileNameMatch[1];
                    }
                }
                
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            } catch (err) {
                console.error('Export failed:', err);
                validation.value = err?.error || 'Failed to export data';
            } finally {
                page.isLoading = false;
            }
        };

        const getVoucherMerchantDisplayName = (voucher) => {
            if (!voucher) return 'N/A';
            if (voucher.merchant_scope === 'all_corporate') {
                return voucher.provider_name || voucher.corporate_name || voucher.merchant?.branch?.corporate?.name || voucher.merchant?.name || 'All Corporate';
            }
            if (Array.isArray(voucher.allowed_merchants) && voucher.allowed_merchants.length > 1) {
                return voucher.provider_name || voucher.corporate_name || voucher.merchant?.branch?.corporate?.name || voucher.merchant?.name || 'Multiple Merchants';
            }
            return voucher.provider_name || voucher.merchant_name || voucher.merchant?.name || 'N/A';
        };

        return {
            page,
            getVoucherMerchantDisplayName,
            destroy,
            fields,
            load_state,
            meta,
            navPage,
            selectedBusinessProfile,
            merchants,
            selectMerchant,
            voucherRedeemSearch,
            selectVoucherRedeem,
            searchBy,
            sortDesc,
            dateRange,
            thisComponentShow,
            write,
            selfLoaded,
            formatDateOnly,
            formatTimeOnly,
            memberSelected,
            members,
            handleSelectedChanged,
            searchBar,
            handleSelectedMember,
            isSearchActive,
            handleSearchChange,
            handleSortChange,
            applyFilters,
            refreshData,
            resetFilters,
            datePicker,
            handleDateRangeChange,
            clearDateRange,
            showDateTip,
            isDateRangeActive,
            searchOptions,
            sortOptions,
            showTooltip,
            clearSearchOption,
            showSearchPlaceholder,
            showSortPlaceholder,
            availableSearchOptions,
            availableSortOptions,
            clearSortOption,
            claimedVoucher,
            draftClaimedVoucher,
            searchKeyword,
            isMobile,
            checkMobileView,
            filterContainer,
            modal,
            openAddModal,
            openClaimModal,
            openInfoModal,
            handleModalSuccess,
            handleModalClose,
            validation,
            saveCurrentState,
            restoreSavedState,
            handleInfoClick,
            handleClaimClick,
            paginationKey,
            download_state
        }
    },
    computed: {
        ... mapState({
            // arrow functions can make the code very succinct!
            voucherRedeems: state => state.VoucherRedeem.voucherRedeems,
            searchBy: state => state.VoucherRedeem.search
        }),
    },
}
</script>

<style scoped>
/* Filter and Action Bar Styling */
.filter-action-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-end; /* Align to bottom for balance with headers */
    gap: 20px;
    flex-wrap: wrap;
    background-color: #f8fafc;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
}

.filter-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
    background: transparent;
    border: none;
    box-shadow: none;
}

.filter-section-horizontal {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    height: 46px;
}

.action-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.section-label-tabs {
    display: flex;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
}

.label-tab {
    padding: 6px 16px;
    font-size: 13px;
    font-weight: 600;
    color: var(--primary-color);
    background: white;
    border-radius: 6px;
    box-shadow: none;
    border: 1px solid #e2e8f0;
    white-space: nowrap;
}

.filter-controls {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
    flex: 1;
}

/* Desktop styles: Single row aligned to the right */
@media (min-width: 769px) {
    .filter-action-wrapper {
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 16px;
    }

    .filter-controls {
        flex-wrap: wrap;
        flex: 1 1 auto;
        justify-content: flex-start;
        gap: 16px;
    }

    .action-section {
        flex-direction: row;
        align-items: flex-end;
        flex: 0 0 auto;
        margin-left: auto;
    }
}

.merchant-filter {
    min-width: 200px;
}

/* Custom Search Box */
.search-box-custom {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: max-content;
}

.search-type-tabs {
    display: flex;
    gap: 4px;
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    width: fit-content;
    flex-wrap: wrap;
}

.tab-btn {
    border: none;
    background: transparent;
    padding: 6px 14px;
    font-size: 12px;
    font-weight: 500;
    color: #64748b;
    border-radius: 6px;
    transition: all 0.2s;
    cursor: pointer;
    white-space: nowrap;
}

.tab-btn.active {
    background: white;
    color: var(--primary-color);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    font-weight: 600;
}

.search-input-wrapper {
    display: flex;
    align-items: center;
    gap: 0;
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0;
    transition: all 0.2s;
}

.search-input-wrapper:focus-within {
    border-color: var(--primary-color);
    box-shadow: 0 0 0 2px rgba(var(--primary-rgb), 0.1);
}

.search-input-wrapper input {
    border: none;
    padding: 8px 12px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
}

.search-input-wrapper select.custom-select-transparent {
    border: none;
    padding: 10px 16px;
    font-size: 14px;
    width: 100%;
    outline: none;
    background: transparent;
    color: #334155;
    box-shadow: none;
}

.search-input-wrapper select.custom-select-transparent:focus {
    box-shadow: none;
    border: none;
}

.btn-search {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 6px;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
}

.btn-search:hover {
    background: #e2e8f0;
    color: var(--primary-color);
}

.search-input-wrapper .btn-search {
    position: relative;
    width: 44px;
    height: 42px;
    border-radius: 0 8px 8px 0;
    background: transparent;
}

.search-input-wrapper .btn-search:hover {
    background: #f1f5f9;
}

.search-input-wrapper .btn-search::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1.1px;
    height: 60%;
    background: linear-gradient(to bottom, rgba(203, 213, 225, 0), rgba(203, 213, 225, 1), rgba(203, 213, 225, 0));
    pointer-events: none;
}

/* Date Range Box */
.date-range-box {
    display: flex;
    align-items: center;
    gap: 8px;
}

.date-range-box .input-container {
    position: relative;
    background: white;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 0 4px;
    display: flex;
    align-items: center;
    max-width: 260px;
}

.date-range-box .input-container input {
    border: none;
    padding: 8px 12px;
    font-size: 14px;
    outline: none;
    background: transparent;
    width: 100%;
}

.date-range-box .btn-clear-date {
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0 8px;
    font-size: 14px;
    display: flex;
    align-items: center;
    outline: none;
}

.date-range-box .calendar-icon {
    color: #94a3b8;
    margin-right: 8px;
}

.pagination-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 0 16px 0;
    margin-top: 8px;
}

.date-input-group {
    display: flex;
    align-items: center;
    gap: 8px;
}

.date-input-group > div {
    min-width: 140px;
}

.date-separator {
    color: #94a3b8;
    font-weight: 500;
}

.btn-filter-date {
    background: var(--primary-color);
    color: white;
    border: none;
    width: 38px;
    height: 38px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-filter-date:hover {
    filter: brightness(0.9);
}

.action-buttons-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-refresh {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #64748b;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.btn-refresh:hover {
    background-color: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
}

.btn-apply {
    background-color: white;
    color: var(--primary-color);
    border: 1px solid var(--primary-color);
    font-weight: 600;
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 6px;
    transition: all 0.2s;
}

.btn-apply:hover {
    background-color: var(--primary-color);
    color: white;
}

.btn-export {
    background-color: #fff;
    border: 1px solid #e2e8f0;
    color: #475569;
    font-weight: 600;
    font-size: 13px;
    padding: 0 16px;
    height: 40px;
    display: flex;
    align-items: center;
    transition: all 0.2s;
}

.btn-export:hover {
    background-color: #f1f5f9;
    border-color: #cbd5e1;
}

.btn-add {
    background-color: var(--primary-color);
    color: white;
    font-weight: 600;
    font-size: 13px;
    padding: 0 20px;
    height: 40px;
    display: flex;
    align-items: center;
    border: none;
    transition: all 0.2s;
}

.btn-add:hover {
    filter: brightness(0.9);
    color: white;
}

.header-title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.25rem 0;
    display: flex;
    align-items: center;
}

.header-subtitle {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0;
}

    .form-group {
        width: 250px;
        text-align: left;
        padding-left: 16px;
    }

    .parent-flex-container {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    
    .button-container {
        width: 50px;
        height: 50px;
        display: flex;
    }

    .filter-section {
        max-width: 100%;
    }

    .filters {
        display: flex;
        gap: 1rem;
        flex-wrap: wrap;
        align-items: flex-end;
        max-width: 100%;
    }

    .top-filters {
        display: flex;
        gap: 1rem;
        flex-wrap: nowrap;
        align-items: flex-start;
    }

    .search-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        min-width: 200px;
        max-width: 250px;
        cursor: pointer;
    }

    .sort-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        min-width: 200px;
        max-width: 250px;
        cursor: pointer;
    }

    .input-group {
        width: 100%;
        cursor: pointer;
    }

    .input-group-date {
        flex: 1;
        min-width: 250px;
        max-width: 250px;
    }

    .switch-container {
        flex: 0 0 auto;
        margin-left: 2%;
        /* max-width: 100%; */
    }

    .bottom-filters {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: space-between;
    }

    .right-group {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-left: auto;
    }

    .input-group {
        flex: 1;
        max-width: 200px;
    }

    .button-group {
        display: flex;
        margin-left: auto;
        flex-shrink: 0;
        gap: 0.5rem;
    }

    @media (max-width: 768px) {
        .right-group {
            width: 100%;
            justify-content: space-between;
            margin-left: 0;
        }
    }

    .label-custom {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
        color: #495057;
    }

    .custom-select {
        position: relative;
        width: 100%;
    }

    .custom-select select {
        width: 100%;
        padding: 0.5rem 3rem 0.5rem 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        appearance: none;
        background-color: white;
    }

    .select-icon {
        right: 10px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
    }

    .input-container {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .input-container input {
        height: 100%;
        padding: 0.5rem 1rem;
        line-height: 1.5;
        cursor: pointer;
    }

    #mobile-date-picker input {
        width: 100%;
    }

    .input-container .calendar-icon {
        position: absolute;
        right: 10px; /* Adjust this value as needed */
        top: 50%;
        transform: translateY(-50%);
        pointer-events: none;
        cursor: pointer;
        color: var(--primary-color, #FC6666); /* Adjust the color as needed */
    }

    .calendar-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        color: #6c757d;
    }

    .switch-container {
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: .4s;
        border-radius: 34px;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: .4s;
        border-radius: 50%;
    }

    #claimed-voucher-slider:before {
        height: 20px;
        width: 20px;
    }

    #claimed-voucher-switch {
        height: 28px;
    }

    input:checked + .slider {
        background-color: var(--primary-color, #2196F3);
    }

    input:checked + .slider:before {
        transform: translateX(25px);
    }

    input#claimed-voucher-switch:checked + .slider:before {
        transform: translateX(34px) !important;
    }

    .apply-button, .clear-button, .close-button {
        padding: 0.5rem 1.5rem;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .apply-button {
        background-color: var(--primary-color, #0d6efd);
        color: white;
    }

    .apply-button:hover {
        background-color: var(--primary-color, #0b5ed7);
        filter: brightness(85%);
    }

    .clear-button {
        background-color: #6c757d;
        color: white;
    }

    .clear-button:hover {
        background-color: #5c636a;
    }

    .close-button {
        background-color: #cb5b5b;
        color: white;
    }    

    @media (max-width: 768px) {
        .filters {
            flex-direction: column;
        }
        
        .top-filters {
            flex-direction: column;
        }
        
        .search-container {
            width: 100%;
        }
        
        .input-group-date {
            width: 100%;
        }
        
        .switch-container {
            margin-left: 0;
            width: 100%;
            justify-content: center;
        }
    }

    .flatpickr-input {
        width: 106%;
        font-weight: 700;
        font-size: 14px;
        border: 1px solid rgba(0, 0, 0, 0.25);
        height: 47px;
        border-radius: 4px;
        padding: 0.375rem 0.75rem;
        background-clip: padding-box;
        background-color: #fff !important;
    }

    .right-button-group {
        display: flex;
        gap: 0.5rem;
    }

    .nav {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /* Untuk responsif */
    @media (max-width: 768px) {
        .right-button-group {
            margin-left: 0;
            width: 100%;
            margin-top: 0.5rem;
        }
    }

    .reload-container {
        flex: 0 0 10%;
        position: relative;
    }

    .refresh-tooltip {
        position: absolute;
        bottom: 100%;
        left: 50%;
        transform: translateX(-50%);
        background: rgba(0,0,0,0.8);
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 0.75rem;
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;
        pointer-events: none;
    }

    .refresh-tooltip::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -4px;
        border-width: 4px;
        border-style: solid;
        border-color: rgba(0,0,0,0.8) transparent transparent transparent;
    }

    .reload-container:hover .refresh-tooltip {
        opacity: 1;
    }

    .clear-icon {
        right: 30px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        color: #999;
        font-size: 1.2rem;
        padding: 0 5px;
        z-index: 2;
    }

    .clear-icon:hover {
        color: var(--primary-color, #ff4444);
    }

    .placeholder-shown {
        color: #6c757d;
        cursor: pointer;
    }

    select option:not([disabled]) {
        color: #212529;
    }

    .search-input {
        width: 100%;
        padding: 0.5rem 1rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out;
    }

    .search-input:focus {
        border-color: var(--primary-color, #86b7fe);
        outline: 0;
        box-shadow: 0 0 0 0.25rem var(--secondary-color, rgba(13, 110, 253, 0.25));
    }

    .nav.nav-pills.card-header-pills.justify-content-between {
        margin-left: 2.5%;
        max-width: 75%;
    }

    .input-group#search-keyword {
        width: 385px;
        max-width: 600px !important;
    }

    .filter-label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 600;
        color: #333;
        font-size: 12px;
        text-align: center;
    }

    .filter-group {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        justify-content: center;
        align-items: center;
    }

    .filter-label-container {
        text-align: center;
    }

    .switch-container.vertical {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 0.5rem;
        margin-left: 0 !important;
    }

    .switch-label {
        order: -1;
    }

    .switch-label:last-child {
        order: 1;
    }

    @media (max-width: 768px) {
        .filter-group {
            width: 100%;
        }
        .switch-container.vertical {
            justify-content: center;
        }
    }

    .mobile-filter-trigger {
        flex: 0 0 15%;
        position: -webkit-sticky;
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .mobile-filter-trigger button {
        width: 100%;
        background-color: initial;
        border: none;
        align-items: center;
        justify-content: center;
        color: white;
    }

    .mobile-filter-trigger li {
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        display: flex;
    }

    .nav-item.btn {
        box-sizing: border-box;
        margin: 0;
    }

    .nav-link.text-white {
        justify-content: center;
        padding: 0.25rem;
    }

    .mobile-filter-item {
        margin-bottom: 15px;
    }

    .custom-dropdown-container {
        position: relative;
        width: 200px;
        cursor: pointer;
        border: 1px solid var(--primary-color, #ff4b4b);
        border-radius: 8px;
        background: white;
    }

    .custom-dropdown-container input {
        border: none;
    }

    .selected-option {
        padding: 10px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333;
    }

    .dropdown-icon {
        font-size: 12px;
        color: var(--primary-color, #ff4b4b);
        transition: transform 0.2s;
    }

    .custom-dropdown-options {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #eee;
        border-radius: 8px;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        z-index: 100;
        max-height: 250px;
        overflow-y: auto;
    }

    .dropdown-option {
        padding: 12px 15px;
        color: #444;
        transition: all 0.2s;
    }

    .dropdown-option:hover {
        background: var(--secondary-color, #fff5f5);
        color: var(--primary-color, #ff4b4b);
    }

    /* Animasi saat dropdown aktif */
    .custom-dropdown-options {
        transform-origin: top;
        animation: scaleIn 0.15s ease-out;
    }

    @keyframes scaleIn {
        from {
            transform: scaleY(0);
            opacity: 0;
        }
        to {
            transform: scaleY(1);
            opacity: 1;
        }
    }

    .status-badge {
        padding: 0.35rem 0.75rem;
        border-radius: 20px;
        font-size: 0.75rem;
        font-weight: 500;
        white-space: nowrap;
        display: inline-block;
        text-align: center;
    }

    /* Table Styles */
    .voucher-list-table {
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        overflow: hidden;
    }

    .voucher-list-table th,
    .voucher-list-table td {
        padding: 10px 12px !important;
        vertical-align: middle;
    }

    .voucher-row-clickable {
        transition: background-color 0.2s;
    }

    .voucher-row-clickable:hover {
        background-color: #f8fafc !important;
    }

    .status-active {
        background-color: #ecfdf5 !important;
        color: #065f46 !important;
        border: 1px solid #a7f3d0;
    }

    .status-primary {
        background-color: #eff6ff !important;
        color: #1e40af !important;
        border: 1px solid #bfdbfe;
    }

    .status-danger {
        background-color: #fef2f2 !important;
        color: #991b1b !important;
        border: 1px solid #fecaca;
    }

    .status-default {
        background-color: #f8fafc !important;
        color: #64748b !important;
        border: 1px solid #e2e8f0;
    }

    /* Modern Date Formatting */
    .modern-date {
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    .modern-date .date-main {
        font-weight: 500;
        color: #334155;
        font-size: 12px;
        white-space: nowrap;
    }

    .modern-date .time-sub {
        font-size: 12px;
        color: #64748b;
        display: flex;
        align-items: center;
        gap: 4px;
        white-space: nowrap;
    }

    /* Action Buttons in Table */
    .btn-action {
        padding: 6px 14px;
        font-size: 12px;
        font-weight: 600;
        border-radius: 8px;
        transition: all 0.2s ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        border: none;
        cursor: pointer;
        white-space: nowrap;
        min-width: 125px;
    }

    .text-truncate-2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
    }

    .btn-claim {
        background-color: var(--primary-color, #F27178);
        color: var(--text-button, #ffffff);
        border: 1px solid var(--primary-color, #F27178);
        transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn-claim:hover {
        background-color: var(--secondary-color, #FEE9E9);
        color: var(--primary-color, #F27178);
        border-color: var(--primary-color, #F27178);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px var(--primary-light, rgba(242, 113, 120, 0.25));
    }

    .btn-info-action {
        background-color: #eff6ff;
        color: #1e40af;
    }

    .btn-info-action:hover {
        background-color: #dbeafe;
        color: #1e3a8a;
    }

    @media (max-width: 991px) {
        .filter-action-wrapper {
            flex-direction: column;
            align-items: stretch;
            gap: 20px;
        }

        .filter-controls {
            width: 100%;
        }

        .custom-dropdown-container {
            width: 100%;
        }
        
        .selected-option {
            padding: 8px 12px;
            font-size: 14px;
        }

        .search-box-custom {
            width: 100%;
        }

        .search-type-tabs {
            width: 100%;
            flex-wrap: nowrap;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
            padding: 6px;
            background: #f8fafc;
            scrollbar-width: none;
        }

        .search-type-tabs::-webkit-scrollbar {
            display: none;
        }

        .tab-btn {
            flex: 0 0 auto;
            white-space: nowrap;
        }

        .action-section {
            width: 100%;
        }

        .action-buttons-group {
            width: 100%;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
        }

        .btn-action-secondary {
            width: 100%;
            justify-content: center;
            padding: 0 12px;
        }

        .btn-add {
            width: 100%;
            justify-content: center;
        }
    }
</style>